var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Box, Stepper, Step, StepButton, Button, Grid, CircularProgress, Typography, StepLabel, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';
import SendIcon from '@mui/icons-material/Send';
import SaveIcon from '@mui/icons-material/Save';
import CompanyInfoStepForm from './company-step';
import WebsitesInfoStep from './websites-step';
import OwnersStep from './owners-step';
import ProcessingStep from './processing-step';
import IntegrationStep from './integration-step';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { ComponentToPrint } from './to-print/print-form';
import PictureAsPdf from '@mui/icons-material/PictureAsPdf';
import { Check } from '@mui/icons-material';
var steps = [
    {
        key: 'step1',
        label: 'Company information',
        description: 'TBD'
    },
    {
        key: 'step2',
        label: 'Website(s) information',
        description: 'TBD'
    },
    {
        key: 'step3',
        label: 'Directors and owners',
        description: 'TBD'
    },
    {
        key: 'step4',
        label: 'Processing information',
        description: 'TBD'
    },
    {
        key: 'step5',
        label: 'Integration information',
        description: 'TBD'
    }
];
var QontoConnector = styled(StepConnector)(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(stepConnectorClasses.alternativeLabel)] = {
            top: 10,
            left: 'calc(-50% + 16px)',
            right: 'calc(50% + 16px)',
        },
        _b["&.".concat(stepConnectorClasses.active)] = (_c = {},
            _c["& .".concat(stepConnectorClasses.line)] = {
            // borderColor: '#0277BD',
            },
            _c),
        _b["&.".concat(stepConnectorClasses.completed)] = (_d = {},
            _d["& .".concat(stepConnectorClasses.line)] = {
            // borderColor: '#0277BD',
            },
            _d),
        _b["& .".concat(stepConnectorClasses.line)] = {
            borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
            borderTopWidth: 3,
            borderRadius: 1,
        },
        _b);
});
var QontoStepIconRoot = styled('div')(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    return (__assign(__assign({ color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0', display: 'flex', height: 22, alignItems: 'center' }, (ownerState.active && {
        color: '#0277BD',
    })), { '& .QontoStepIcon-completedIcon': {
            color: '#0277BD',
            zIndex: 1,
            fontSize: 18,
        }, '& .QontoStepIcon-circle': {
            width: 15,
            height: 15,
            borderRadius: '50%',
            backgroundColor: 'currentColor',
        } }));
});
function QontoStepIcon(props) {
    var active = props.active, completed = props.completed, className = props.className;
    return (_jsx(QontoStepIconRoot, __assign({ ownerState: { active: active }, className: className }, { children: completed ? (_jsx(Check, { className: "QontoStepIcon-completedIcon" })) : (_jsx("div", { className: "QontoStepIcon-circle" })) })));
}
var WizardContainer = /** @class */ (function (_super) {
    __extends(WizardContainer, _super);
    function WizardContainer(props) {
        var _this = _super.call(this, props) || this;
        Object.defineProperty(_this, "companyComponentRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "websitesComponentRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "printRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "totalSteps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () { return steps.length; }
        });
        Object.defineProperty(_this, "isLastStep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () { return _this.state.activeStep === _this.totalSteps() - 1; }
        });
        Object.defineProperty(_this, "completedSteps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () { return Object.keys(_this.state.completed).length; }
        });
        Object.defineProperty(_this, "allStepsCompleted", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () { return _this.completedSteps() === _this.totalSteps(); }
        });
        Object.defineProperty(_this, "handleNext", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var newActiveStep = _this.isLastStep() && !_this.allStepsCompleted()
                    ? steps.findIndex(function (step, i) { return !(i in _this.state.completed); })
                    : _this.state.activeStep + 1;
                _this.setActiveStep(newActiveStep);
            }
        });
        Object.defineProperty(_this, "handleBack", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                _this.setActiveStep(_this.state.activeStep - 1);
            }
        });
        Object.defineProperty(_this, "handleStep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (step) { return function () {
                _this.setActiveStep(step);
            }; }
        });
        _this.state = {
            activeStep: 0,
            completed: {},
            isSnackOpen: false,
            isDialogOpen: false
        };
        _this.companyComponentRef = React.createRef();
        _this.websitesComponentRef = React.createRef();
        _this.printRef = React.createRef();
        return _this;
    }
    Object.defineProperty(WizardContainer.prototype, "setActiveStep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (step) {
            this.setState(__assign(__assign({}, this.state), { activeStep: step }));
        }
    });
    Object.defineProperty(WizardContainer.prototype, "setCompleted", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (completedItem) {
            this.setState(__assign(__assign({}, this.state), { completed: completedItem }));
        }
    });
    Object.defineProperty(WizardContainer.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            return (_jsxs(Box, __assign({ sx: { width: '100%' } }, { children: [this.props.applicationFormStore.isAdminMode ?
                        _jsx(Grid, __assign({ container: true, justifyContent: "flex-end" }, { children: this.renderPdfExport() }))
                        : _jsx(_Fragment, {}), _jsx(Stepper, __assign({ nonLinear: true, activeStep: this.state.activeStep, alternativeLabel: true, connector: _jsx(QontoConnector, {}) }, { children: steps.map(function (item, index) {
                            var labelProps = {};
                            if (_this.isStepFailed(index)) {
                                labelProps.optional = (_jsxs(Typography, __assign({ variant: "caption", color: "error" }, { children: ["Missing fields: ", _this.stepErrorFieldCount(index)] })));
                                labelProps.color = "error";
                            }
                            return (_jsx(Step, { children: _jsx(StepButton, __assign({}, labelProps, { onClick: _this.handleStep(index) }, { children: _jsx(StepLabel, __assign({ StepIconComponent: QontoStepIcon }, { children: item.label })) })) }, item.key));
                        }) })), _jsx("div", { children: this.props.applicationFormStore.isLoaded ?
                            this.renderComponent(this.state.activeStep) :
                            _jsx(Box, __assign({ sx: { display: 'flex' } }, { children: _jsx(CircularProgress, { color: "primary" }) })) }), _jsxs(Grid, __assign({ container: true, justifyContent: "flex-end" }, { children: [_jsx(Button, __assign({ disabled: this.isDisabledSave(), variant: "contained", color: 'success', startIcon: _jsx(SaveIcon, {}), onClick: function (e) { return _this.onSave(); } }, { children: "Save for later" })), "\u00A0", _jsx(Button, __assign({ disabled: this.isDisabledSubmit(), variant: "contained", endIcon: _jsx(SendIcon, {}), onClick: function (e) { return _this.onSubmit(); } }, { children: "Submit" }))] })), _jsx(Grid, __assign({ container: true, justifyContent: "flex-end" }, { children: _jsxs(Box, __assign({ sx: { display: 'flex', flexDirection: 'row', pt: 2 } }, { children: [_jsx(Button, __assign({ variant: "contained", disabled: this.state.activeStep === 0, onClick: function () { return _this.handleBack(); }, sx: { mr: 1 } }, { children: "Back" })), _jsx(Box, { sx: { flex: '1 1 auto' } }), this.state.activeStep !== steps.length - 1 ? _jsx(Button, __assign({ variant: "contained", onClick: function () { return _this.handleNext(); } }, { children: "Next" })) : _jsx(_Fragment, {})] })) })), _jsx(Snackbar, __assign({ open: this.state.isSnackOpen, autoHideDuration: 5000, onClose: function (e) { return _this.onCloseSnack(e); } }, { children: _jsx(Alert, __assign({ severity: "success", sx: { width: '100%' } }, { children: "Form has been successfully updated" })) })), _jsxs(Dialog, __assign({ open: this.state.isDialogOpen, onClose: function () { return _this.onCloseDialog(false); }, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" }, { children: [_jsx(DialogContent, { children: _jsx(DialogContentText, __assign({ id: "alert-dialog-description" }, { children: "Are you sure you want to submit your application? You will not be able to change the submitted information. If you want however to make any changes you will have to contact our support" })) }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ onClick: function () { return _this.onCloseDialog(true); } }, { children: "Yes" })), _jsx(Button, __assign({ onClick: function () { return _this.onCloseDialog(false); } }, { children: "No" }))] })] }))] })));
        }
    });
    Object.defineProperty(WizardContainer.prototype, "renderPdfExport", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            return (_jsxs(Box, __assign({ sx: { margin: 2 } }, { children: [_jsx(ReactToPrint, __assign({ content: function () { return _this.printRef; }, pageStyle: "@media print { @page { size: A3, margin: 5px } body { font-size: 12px }" }, { children: _jsx(PrintContextConsumer, { children: function (_a) {
                                var handlePrint = _a.handlePrint;
                                return (_jsx(Button, __assign({ variant: "contained", color: 'success', startIcon: _jsx(PictureAsPdf, {}), onClick: handlePrint }, { children: "Export PDF" })));
                            } }) })), _jsx("div", __assign({ style: { display: "none" } }, { children: _jsx(ComponentToPrint, { formWizard: this.props.applicationFormStore.currentFormWizard, cardTypes: this.props.applicationFormStore.cardTypes, ref: function (el) { return _this.printRef = el; } }) }))] })));
        }
    });
    Object.defineProperty(WizardContainer.prototype, "renderComponent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (step) {
            switch (step) {
                case 0:
                    return _jsx(CompanyInfoStepForm, { applicationFormStore: this.props.applicationFormStore, isSubmitted: this.props.applicationFormStore.isSubmitted });
                case 1:
                    return _jsx(WebsitesInfoStep, { applicationFormStore: this.props.applicationFormStore, isSubmitted: this.props.applicationFormStore.isSubmitted });
                case 2:
                    return _jsx(OwnersStep, { applicationFormStore: this.props.applicationFormStore, isSubmitted: this.props.applicationFormStore.isSubmitted });
                case 3:
                    return _jsx(ProcessingStep, { applicationFormStore: this.props.applicationFormStore, isSubmitted: this.props.applicationFormStore.isSubmitted });
                case 4:
                    return _jsx(IntegrationStep, { applicationFormStore: this.props.applicationFormStore, isSubmitted: this.props.applicationFormStore.isSubmitted });
            }
        }
    });
    Object.defineProperty(WizardContainer.prototype, "stepErrorFieldCount", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (step) {
            switch (step) {
                case 0:
                    return this.props.applicationFormStore.companyErrorsFieldsCount;
                case 1:
                    return this.props.applicationFormStore.websitesErrorsFieldsCount;
                case 2:
                    return this.props.applicationFormStore.ownersErrorsFieldsCount;
                case 3:
                    return this.props.applicationFormStore.processingErrorsFieldsCount;
                case 4:
                    return false;
            }
        }
    });
    Object.defineProperty(WizardContainer.prototype, "isDisabledSave", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.props.applicationFormStore.isSubmitted;
        }
    });
    Object.defineProperty(WizardContainer.prototype, "isDisabledSubmit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this.props.applicationFormStore.isAdminMode) {
                return false;
            }
            else {
                if (this.props.applicationFormStore.companyErrorsFieldsCount === 0 &&
                    this.props.applicationFormStore.websitesErrorsFieldsCount === 0 &&
                    this.props.applicationFormStore.ownersErrorsFieldsCount === 0 &&
                    this.props.applicationFormStore.processingErrorsFieldsCount === 0 &&
                    !this.props.applicationFormStore.isSubmitted) {
                    return false;
                }
                else if (this.props.applicationFormStore.isSubmitted) {
                    return true;
                }
                else {
                    return true;
                }
            }
        }
    });
    Object.defineProperty(WizardContainer.prototype, "isStepFailed", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (step) {
            switch (step) {
                case 0:
                    return this.props.applicationFormStore.companyErrorsFieldsCount > 0;
                case 1:
                    return this.props.applicationFormStore.websitesErrorsFieldsCount > 0;
                case 2:
                    return this.props.applicationFormStore.ownersErrorsFieldsCount > 0;
                case 3:
                    return this.props.applicationFormStore.processingErrorsFieldsCount > 0;
                case 4:
                    return false;
            }
        }
    });
    Object.defineProperty(WizardContainer.prototype, "onSubmit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this.props.applicationFormStore.isAdminMode) {
                this.props.applicationFormStore.submit();
                this.onOpenSnack();
            }
            else {
                this.onOpenDialog();
            }
        }
    });
    Object.defineProperty(WizardContainer.prototype, "onSave", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.props.applicationFormStore.save();
            this.onOpenSnack();
        }
    });
    Object.defineProperty(WizardContainer.prototype, "onOpenSnack", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.setState(__assign(__assign({}, this.state), { isSnackOpen: true }));
        }
    });
    Object.defineProperty(WizardContainer.prototype, "onCloseSnack", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, reason) {
            this.setState(__assign(__assign({}, this.state), { isSnackOpen: false }));
        }
    });
    Object.defineProperty(WizardContainer.prototype, "onOpenDialog", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.setState(__assign(__assign({}, this.state), { isDialogOpen: true }));
        }
    });
    Object.defineProperty(WizardContainer.prototype, "onCloseDialog", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isOk) {
            if (isOk) {
                this.props.applicationFormStore.submit();
            }
            this.setState(__assign(__assign({}, this.state), { isDialogOpen: false }));
        }
    });
    WizardContainer = __decorate([
        inject('applicationFormStore'),
        observer
    ], WizardContainer);
    return WizardContainer;
}(React.Component));
export default WizardContainer;
